// extracted by mini-css-extract-plugin
export default {"container":"ActressTagList_container__fm9AC","title":"ActressTagList_title__8LW3c","pill":"ActressTagList_pill__OLFyh","pill_text":"ActressTagList_pill_text__uTFB9"};